import { render, staticRenderFns } from "./MyCase.vue?vue&type=template&id=4b3f213a&scoped=true"
import script from "./MyCase.vue?vue&type=script&lang=js"
export * from "./MyCase.vue?vue&type=script&lang=js"
import style0 from "./MyCase.vue?vue&type=style&index=0&id=4b3f213a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f213a",
  null
  
)

export default component.exports